<ng-container [formGroup]="parent">
	<table
		mat-table
		class="list-container mb-3"
		[dataSource]="dataSource"
		matSort
		matSortActive="{{ sort.active }}"
		matSortDisableClear
		formArrayName="array"
		matSortDirection="{{ sort.direction }}"
	>
		<ng-container matColumnDef="empty">
			<th mat-header-cell *matHeaderCellDef class="text-center">
				<em>No unavailable days</em>
			</th>
		</ng-container>

		<ng-container matColumnDef="date">
			<th mat-header-cell *matHeaderCellDef mat-sort-header>Date</th>
			<td mat-cell *matCellDef="let day">
				{{ day.date | date: 'longDate':'utc' }}
			</td>
		</ng-container>

		<ng-container matColumnDef="reason">
			<th mat-header-cell *matHeaderCellDef mat-sort-header>Reason</th>
			<td mat-cell *matCellDef="let day">{{ day.reason }}</td>
		</ng-container>

		<ng-container matColumnDef="edit">
			<th mat-header-cell *matHeaderCellDef>Edit</th>
			<td mat-cell *matCellDef="let day; let i = index">
				<button
					type="button"
					mat-icon-button
					(click)="editDay(day)"
					color="primary"
				>
					<mat-icon>edit</mat-icon>
				</button>
			</td>
		</ng-container>

		<ng-container matColumnDef="delete">
			<th mat-header-cell *matHeaderCellDef>Delete</th>
			<td mat-cell *matCellDef="let day; let i = index">
				<button
					type="button"
					mat-icon-button
					color="warn"
					rpsharedConfirm="Delete unavailable day?"
					(onConfirmed)="array.removeAt(findDayIndex(day))"
				>
					<mat-icon>delete</mat-icon>
				</button>
			</td>
		</ng-container>

		<tr
			mat-header-row
			*matHeaderRowDef="resultColumns"
			[class.hidden]="dataSource.data?.length < 1"
		></tr>
		<tr
			mat-header-row
			*matHeaderRowDef="emptyColumns"
			[class.hidden]="dataSource.data?.length > 0"
		></tr>
		<tr
			mat-row
			*matRowDef="let day; columns: resultColumns"
			[@animateList]
		></tr>
	</table>

	<div fxLayout="row" fxLayoutAlign="space-between center">
		<div>
			<mat-paginator
				class.hidden="true"
				pageSize="5"
				[pageSizeOptions]="[5, 10]"
			></mat-paginator>
		</div>

		<div>
			<button
				mat-mini-fab
				color="warn"
				class="mr-2 remove-button"
				(click)="deleteMultipleDays()"
				matTooltip="Delete Multiple Days"
			>
				<mat-icon>remove</mat-icon>
			</button>
			<button
				mat-mini-fab
				color="primary"
				class="mr-2"
				(click)="addMultipleDays()"
				matTooltip="Add Multiple Days"
			>
				<mat-icon>playlist_add</mat-icon>
			</button>
			<button
				*ngIf="fieldWorkerId > 0"
				type="button"
				class="mr-4"
				(click)="addDay()"
				mat-mini-fab
				color="primary"
				matTooltip="Add Day"
			>
				<mat-icon>add</mat-icon>
			</button>
		</div>
	</div>
</ng-container>
